import Vue from 'vue'
import Router from 'vue-router'
import Topics from '@/components/Topics'
import Topic from '@/components/Topic'
import Alerts from '@/components/Alerts'
import Account from '@/components/Account'



Vue.use(Router)

export default new Router({

    routes: [

        {
            path: '/topics/',
            name: 'Topics',
            component: Topics,
            props: true
        },
        {
            path: '/topic/:topicId',
            name:'Topic',
            component: Topic
        },
        {
            path: '/',
            name: 'Alerts',
            component: Alerts,
            props: true
        }

        ,
        {
            path: '/account/',
            name: 'Account',
            component: Account,
            props: true
        }
    ]
})
